import React from "react";
import { Alert } from "react-bootstrap";

const OrderExpirationAlert = () => {

  return (
    <Alert variant="danger" className="margin-bottom-md">
      This quote has <strong>expired</strong>, as our pricing has changed since. Please create a new quote.
      If you wish to use this quote as a starting point, you can duplicate this quote and the new pricing will be shown.
    </Alert>
  )
}

export default OrderExpirationAlert;
